<template>
  <div>
    <div class="row">
      <Platform />
    </div>
  </div>
</template>

<script>
import Platform from '../components/SalesTracking/platform.vue';

export default {
  components: { Platform },
  mounted() {
    this.auth();
  },
  methods: {
    auth() {
      this.axios.get(`${this.baseUrl}/dashboard/auth`, this.$store.getters.authHeader)
        .catch(() => {
          this.$router.push('/');
        });
    },
  },
};
</script>

<style>

</style>
